import { BrowserModule } from '@angular/platform-browser';
import { NgModule, TRANSLATIONS, TRANSLATIONS_FORMAT, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePT from '@angular/common/locales/pt';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { GrowlModule } from 'primeng/growl';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ListaOrdemServicoComponent } from './lista-ordem-servico/lista-ordem-servico.component';
import { ModelFormComponent } from './model-form/model-form.component';
import { EditarClienteComponent } from './editar-cliente/editar-cliente.component';

// PRIMENG
import {ContextMenuModule} from 'primeng/contextmenu';
import {MenuModule} from 'primeng/menu';
import {ToolbarModule} from 'primeng/toolbar';
import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {InputTextModule} from 'primeng/inputtext';
import {PanelModule} from 'primeng/panel';
import {StepsModule} from 'primeng/steps';
import {OrderListModule} from 'primeng/orderlist';
import {FieldsetModule} from 'primeng/fieldset';
import {PaginatorModule} from 'primeng/paginator';
import { MessageService } from 'primeng/components/common/messageservice';
import {RadioButtonModule} from 'primeng/radiobutton';
import {AdvGrowlModule} from 'primeng-advanced-growl';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import { LoginComponent } from './login/login.component';
import { SobreComponent } from './sobre/sobre.component';
import { HeaderComponent } from './header/header.component';
import { CriarOSComponent } from './criar-os/criar-os.component';
import { CriarOSEnderecoComponent } from './criar-osendereco/criar-osendereco.component';
import { CriarOSTipoOSComponent } from './criar-ostipo-os/criar-ostipo-os.component';
import { OrdemServicoModel, ClienteModel, EnderecoModel, TipoOsModel, OrdemServicoIn, BuscarOrdemServicoIn, PrimeiroAcesso } from './model';
import { CriarOSConfirmacaoComponent } from './criar-osconfirmacao/criar-osconfirmacao.component';
import {JwtInterceptor} from './helper/jwt.interceptor';
import { CriarOSClienteComponent } from './criar-oscliente/criar-oscliente.component';
import {ErrorInterceptor} from './helper';
import {AuthGuard} from './guard';
import {AuthenticationService} from './service/authentication.service';
import { ListaOsEncerradaComponent } from './lista-os-encerrada/lista-os-encerrada.component';
import { PrimeiroAcessoComponent } from './primeiro-acesso/primeiro-acesso.component';
import {DialogService} from '../../node_modules/primeng/components/dynamicdialog/dialogservice'


import { NgxUiLoaderModule, NgxUiLoaderRouterModule, NgxUiLoaderConfig, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
// JQUERY
import { NgxMaskModule } from 'ngx-mask';
import { CookieService } from 'ngx-cookie-service';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { APP_LOCALE_ID } from '../app-locale';
import { MyHttpLogInterceptor } from '../app/http.interceptor';
import { CriarOSAtivoComponent } from './criar-osativo/criar-osativo.component';
import {MensagemService} from "./service/mensagem.service";
import { OrdemServicoDialogComponent } from './ordem-servico-dialog/ordem-servico-dialog.component';
import {FileUploadModule, ListboxModule, PasswordModule} from 'primeng/primeng';
import {AutoCompleteModule, CalendarModule, DataTableModule, KeyFilterModule, MultiSelectModule, SliderModule} from 'primeng/primeng';
import { ImprimirOsDialogComponent } from './imprimir-os-dialog/imprimir-os-dialog.component';
import { AnexoOsDialogComponent } from './anexo-os-dialog/anexo-os-dialog.component';
import { QrCodeDialogComponent } from './qr-code-dialog/qr-code-dialog.component';
import {DataService} from './service/data.service';
import {CriarOSAmbienteComponent} from './criar-osambiente/criar-osambiente.component';
import {AnexarArquivosDialogComponent} from "./anexar-arquivos-dialog/anexar-arquivos-dialog.component";
import {CriarOSAnexoComponent} from "./criar-osanexo/criar-osanexo.component";

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'red',
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 40,
  bgsType: SPINNER.rectangleBounce,
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 5
};

declare const require;
registerLocaleData(localePT);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SobreComponent,
    ListaOrdemServicoComponent,
    ModelFormComponent,
    HeaderComponent,
    CriarOSComponent,
    CriarOSEnderecoComponent,
    CriarOSAmbienteComponent,
    CriarOSTipoOSComponent,
    CriarOSAnexoComponent,
    CriarOSConfirmacaoComponent,
    CriarOSClienteComponent,
    ListaOsEncerradaComponent,
    PrimeiroAcessoComponent,
    CriarOSAtivoComponent,
    OrdemServicoDialogComponent,
    EditarClienteComponent,
    ImprimirOsDialogComponent,
    AnexoOsDialogComponent,
    QrCodeDialogComponent,
    AnexarArquivosDialogComponent
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'portal-cliente'}),
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    TableModule,
    DropdownModule,
    DialogModule,
    InputTextModule,
    InputTextareaModule,
    PanelModule,
    ButtonModule,
    GrowlModule,
    RouterModule,
    // PRIMENG
    ContextMenuModule,
    MenuModule,
    ToolbarModule,
    PaginatorModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    PanelModule,
    StepsModule,
    OrderListModule,
    FieldsetModule,
    RadioButtonModule,
    AdvGrowlModule,
    DynamicDialogModule,
    MessageModule,
    MessagesModule,
    // JQuery
    NgxMaskModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderRouterModule,
    InfiniteScrollModule,
    PasswordModule,
    AutoCompleteModule,
    DataTableModule,
    KeyFilterModule,
    MultiSelectModule,
    SliderModule,
    CalendarModule,
    ReactiveFormsModule,
    FileUploadModule,
    ListboxModule
  ],
  providers: [
    I18n,
    { provide: TRANSLATIONS_FORMAT,
      useValue: 'xlf'},

    { provide: TRANSLATIONS,
      useFactory: (locale) => {
        locale = locale || 'pt-BR';
        return require(`raw-loader!../locale/messages.${locale}.xlf`); },
      deps: [LOCALE_ID]
    },
    { provide: LOCALE_ID, useValue: APP_LOCALE_ID},
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MyHttpLogInterceptor, multi: true },
    AuthenticationService,
    MessageService,
    MensagemService,
    AuthGuard,
    OrdemServicoModel,
    ClienteModel,
    EnderecoModel,
    OrdemServicoIn,
    BuscarOrdemServicoIn,
    CriarOSConfirmacaoComponent,
    TipoOsModel,
    PrimeiroAcesso,
    FormBuilder,
    CriarOSComponent,
    CookieService,
    DialogService,
    DataService
  ],
  entryComponents: [OrdemServicoDialogComponent, ImprimirOsDialogComponent, AnexoOsDialogComponent, QrCodeDialogComponent
    , AnexarArquivosDialogComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
